import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./TransferActionForm";
import {cancelRemovePalletFromTransfer, successRemovePalletFromTransfer} from "../../../actions/StockTransferApiActions";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";

class RemovePalletFromTransferFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit() {
    const data = {
      transferId: this.props.transferId,
      palletId: this.props.palletId,
    };
    return this.props.removePalletFromTransfer(data)
      .then((response) => {
        if (response.data.removePalletFromTransfer.errors.length <= 0) {
          this.props.successRemovePalletFromTransfer();
        } else {
          let errors = createValidationErrors(response.data.removePalletFromTransfer.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelRemovePalletFromTransfer();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        submitLabel="Remove Pallet"
        message={`Remove pallet ${this.props.palletId} from this transfer?`}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REMOVE_PALLET_FROM_TRANSFER = gql`
  mutation removePalletFromTransfer($data: RemovePalletFromTransferInput!) {
    removePalletFromTransfer(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REMOVE_PALLET_FROM_TRANSFER, {
    props: ({ mutate }) => ({
      removePalletFromTransfer: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRemovePalletFromTransfer, successRemovePalletFromTransfer})(withMutation(RemovePalletFromTransferFormContainer));
